import React, { useEffect, useMemo, useState } from "react";
import {
  Drawer,
  Box,
  IconButton,
  Typography,
  Grid,
  useMediaQuery,
  Button,
  CardContent,
  Card,
  Tooltip,
} from "@mui/material";
import { Close, Delete, Margin } from "@mui/icons-material";
import { CmpTypographyField } from "../../Component/Common/ToolBox/ToolBox";

import moment from "moment";
import { fAlertToast, getStatusStyleV1 } from "../../Utility/Utilitys";
import { IMPURItem_Delete, IMPURItemA_GetRow, IMPURItemsB_Excel_Format_PO } from "../../Server/ApiV2";
import { DataGridPro } from "@mui/x-data-grid-pro";
import ItemCreationModal from "./ItemCreationModal";
import { confirmAlert } from "react-confirm-alert";
import * as XLSX from "xlsx";
import ArticleIcon from "@mui/icons-material/Article"; // excel-like icon
import DeleteIcon from "@mui/icons-material/Delete";
import GridOnIcon from '@mui/icons-material/GridOn';


const ItemCreationSidenav = ({
  open,
  onClose,
  selectedRow,
  setSelectedRow,
  loadSummary,
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const xMediaQuery = useMediaQuery("(max-width:950px)");

  const [data, setData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [header, setHeader] = useState({
    TransId: 0,
    TripId: "",
    TransDate: "",
    Narr: "",
  });

  const fGetrow = async () => {
    try {
      const obj = {
        TripId: selectedRow?.TripId,
      };
      const result = await IMPURItemA_GetRow(obj);
      if (result?.status === 200) {
        setData(result?.data?.ResultSet || []);
      }
    } catch (error) {}
  };

  const handleRowClick = (params) => {
    setHeader(() => ({
      TransId: params?.row?.TransId,
      TripId: params?.row?.TripId,
      TransDate: moment(params?.row?.TransDate).toDate(),
      Narr: params?.row?.Narr,
    }));
    setModalOpen(true);
  };

  const isStatus_A_Row_Disabled = useMemo(() => {
    let selectedObj =
      data.length > 0 &&
      data?.find((item) => item?.TransId === header?.TransId);
    return selectedObj?.Status === "POST";
  }, [data, header?.TransId]);

  const handleDeleteRow = async (TransId) => {
    try {
      confirmAlert({
        title: "Delete Confirmation",
        message: " Are you sure do you want to delete transcation",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: async () => {
              try {
                const res = await IMPURItem_Delete({
                  TransId: TransId,
                });
                if (res?.status === 200) {
                  fAlertToast("SUCCESS", "Deleted Successfully");
                  await fGetrow();
                  await loadSummary();
                } else {
                  fAlertToast(
                    "FAILED",
                    res?.response?.data?.error || res?.message
                  );
                }
              } catch (error) {}
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    } catch (error) {}
  };

  const handlePOExcelDownload = async (TransId) => {
  try {
    const result = await IMPURItemsB_Excel_Format_PO({ TransId });
    if (result?.status === 200) {
      const rows = result?.data?.ResultSet || [];
      if (!rows.length) {
        fAlertToast("FAILED", "No data to export");
        return;
      }
      // ✅ Build Excel from ResultSet
      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "PO");
      // Optional: auto width (basic)
      const colKeys = Object.keys(rows[0] || {});
      ws["!cols"] = colKeys.map((k) => ({
        wch: Math.max(
          k.length,
          ...rows.map((r) => String(r?.[k] ?? "").length)
        ),
      }));
      const fileName = `PO_${TransId}.xlsx`;
      XLSX.writeFile(wb, fileName);
      fAlertToast("SUCCESS", "Excel downloaded");
    }
  } catch (error) {}
};


  useEffect(() => {
    if (open) {
      fGetrow();
    }
  }, [open]);

  return (
    <>
      <Drawer
        anchor="right"
        open={open}
        sx={{
          "& .MuiDrawer-paper": {
            width: { xs: "100%", sm: "100%", md: "90%", lg: "68%" },
          },
        }}
      >
        <Box mt={4}>
          <Box
            sx={{
              backgroundColor: "#1e88e5 ",
              color: "#fff",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 1.5,
              py: 0.5,
              margin: "12px 0",
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: 500, marginLeft: "8px" }}
            >
              Item Creation Detail
            </Typography>

            <IconButton
              onClick={() => {
                onClose();
                setSelectedRow({});
              }}
              sx={{
                color: "#ffffff",
                backgroundColor: "rgba(255,255,255,0.15)",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.25)",
                },
              }}
            >
              <Close />
            </IconButton>
          </Box>
        </Box>

        <Box sx={{ my: vMediaQuery ? 1 : 2, mx: vMediaQuery ? 1 : 2.5 }}>
          <Card variant="elevation" elevation={3} sx={{ mb: 1.5 }}>
            <CardContent sx={{ padding: "8px !important" }}>
              <Grid container spacing={1} pt={0.5} alignItems="center">
                <Grid item xs={12} sm={6} md={3.5}>
                  <Grid container alignItems="center">
                    <Grid item xs={4} sm={4} md={5} xl={4.5}>
                      <CmpTypographyField
                        xfontSize={"13px"}
                        xText={"Trip ID"}
                      />
                    </Grid>

                    <Grid item xs={8} sm={7} md={7} xl={7.5}>
                      <Typography
                        variant="subtitle2"
                        fontSize={vMediaQuery ? "12px" : "13px"}
                      >
                        {selectedRow?.TripId}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6} md={4.5}>
                  <Grid container alignItems="center">
                    <Grid item xs={4} sm={4} md={5} lg={5} xl={4}>
                      <CmpTypographyField xfontSize={"13px"} xText={"Name"} />
                    </Grid>

                    <Grid item xs={8} sm={7} md={7} lg={7} xl={8}>
                      <Typography
                        variant="subtitle2"
                        fontSize={vMediaQuery ? "12px" : "13px"}
                      >
                        {selectedRow?.Name}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Grid container alignItems="center">
                    <Grid item xs={4} sm={4} md={5} lg={5} xl={3}>
                      <CmpTypographyField xfontSize={"13px"} xText={"Buyer"} />
                    </Grid>

                    <Grid item xs={8} sm={8} md={7} lg={7} xl={9}>
                      <Typography
                        variant="subtitle2"
                        fontSize={vMediaQuery ? "12px" : "13px"}
                      >
                        {selectedRow?.BuyerName}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6} md={3.5}>
                  <Grid container alignItems="center">
                    <Grid item xs={4} md={5} xl={4.5}>
                      <CmpTypographyField
                        xfontSize={"13px"}
                        xText={"Expected From"}
                      />
                    </Grid>

                    <Grid item xs={8} md={7} xl={7.5}>
                      <Typography
                        variant="subtitle2"
                        fontSize={vMediaQuery ? "12px" : "13px"}
                      >
                        {selectedRow?.Expt_From
                          ? moment(selectedRow.Expt_From).format("DD/MM/YYYY")
                          : ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6} md={4.5}>
                  <Grid container alignItems="center">
                    <Grid item xs={4} sm={4} md={5} lg={5} xl={4}>
                      <CmpTypographyField
                        xfontSize={"13px"}
                        xText={"Expected To"}
                      />
                    </Grid>

                    <Grid item xs={8} sm={8} md={7} lg={7} xl={8}>
                      <Typography
                        variant="subtitle2"
                        fontSize={vMediaQuery ? "12px" : "13px"}
                      >
                        {selectedRow?.Expt_To
                          ? moment(selectedRow.Expt_To).format("DD/MM/YYYY")
                          : ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  display="flex"
                  justifyContent="flex-end"
                >
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => {
                      setModalOpen(true);
                      setHeader(() => ({
                        TransId: 0,
                        TripId: selectedRow?.TripId,
                        TransDate: moment().toDate(),
                        Narr: "",
                      }));
                    }}
                  >
                    New
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Box
            sx={{
              height: {
                xs: "57vh",
                sm: "62vh",
                md: "66vh",
                xl: "68vh",
              },
              mt: 1,
            }}
          >
            <DataGridPro
              rowHeight={30}
              headerHeight={40}
              rows={data ?? []}
              getRowId={(v) => v.TransId}
              columns={[
                {
                  field: "TransId",
                  headerName: "Trans Id",
                  width: xMediaQuery ? 70 : 60,
                  align: "center",
                  headerAlign: "left",
                },
                {
                  field: "TripName",
                  headerName: " Trip Name",
                  minWidth: 200,
                  flex: 1,
                },
                {
                  field: "TransDate",
                  headerName: "TransDate ",
                  width: xMediaQuery ? 95 : 90,
                  valueFormatter: ({ value }) =>
                    moment(value).format("DD/MM/YYYY") == "Invalid date"
                      ? ""
                      : moment(value).format("DD/MM/YYYY"),
                  align: "center",
                  headerAlign: "left",
                },
                {
                  field: "EnDt",
                  headerName: "Entry Date",
                  width: xMediaQuery ? 95 : 90,
                  valueFormatter: ({ value }) =>
                    moment(value).format("DD/MM/YYYY") == "Invalid date"
                      ? ""
                      : moment(value).format("DD/MM/YYYY"),
                  align: "center",
                  headerAlign: "left",
                },

                {
                  field: "EnByName",
                  headerName: "Entry Name",
                  width: 140,
                  align: "left",
                  headerAlign: "left",
                },
                {
                  field: "Status",
                  headerName: "Status",
                  width: 85,
                  align: "center",
                  headerAlign: "left",
                  renderCell: (params) => {
                    const style = getStatusStyleV1(params.value);
                    return (
                      <div
                        style={{
                          ...style,
                          padding: "2px 8px",
                          borderRadius: "4px",
                          textAlign: "center",
                          width: "100%",
                          fontWeight: "bold",
                        }}
                      >
                        {params.value}
                      </div>
                    );
                  },
                },
                {
                  field: "Narr",
                  headerName: "Narration",
                  minWidth: 200,
                  flex: 1,
                  align: "left",
                  headerAlign: "left",
                },
                {
                  field: "poExcel",
                  headerName: "PO",
                  width: 20,
                  align: "center",
                  headerAlign: "center",
                  sortable: false,
                  filterable: false,
                  disableColumnMenu: true,
                  renderCell: (params) => {
                    const disabled = params?.row?.Status === "ENTER";
                    return (
                      <Tooltip title={disabled ? "" : "Download PO Excel"}>
                        <span>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePOExcelDownload(params?.row?.TransId);
                            }}
                            disabled={disabled}
                          >
                            <GridOnIcon fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                    );
                  },
                },
                {
                  field: "action",
                  headerName: "",
                  width: 20,
                  align: "center",
                  headerAlign: "center",
                  sortable: false,
                  filterable: false,
                  disableColumnMenu: true,
                  renderCell: (params) => (
                    <IconButton
                      size="small"
                      color="error"
                      onClick={(e) => {
                        e.stopPropagation(); // prevent row double click
                        handleDeleteRow(params?.row?.TransId);
                      }}
                      disabled={params?.row?.Status === "POST"}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  ),
                },
              ]}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? "mui-even-row"
                  : "mui-odd-row"
              }
              sx={{
                border: 1,
                borderColor: "primary.light",
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#0d73bb",
                  color: "white",
                },
              }}
              hideFooter
              onRowDoubleClick={handleRowClick}
            />
          </Box>
        </Box>
      </Drawer>
      <ItemCreationModal
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        header={header}
        setHeader={setHeader}
        loadAGetRow={fGetrow}
        loadSummary={loadSummary}
        headerDetail={selectedRow}
        disable={isStatus_A_Row_Disabled}
      />
    </>
  );
};

export default ItemCreationSidenav;
